import React from 'react';
import ReactDOM from 'react-dom';
import {App} from './main/main';

const render = () => {
  ReactDOM.render(<App/>, document.getElementById('root'));
};

render();
